import React, { useEffect, useState } from "react"
import logo from "../assets/ecsenz_logo.svg"
import logoWhite from "../assets/ecsenz_logoWhite.svg"
import contactIcon from "../assets/contact.svg"
import profileIcon from "../assets/profile.svg"

function useFeatureFlag(flag: string): boolean {
    const params = new URLSearchParams(window.location.search)
    return params.get(flag) === "true"
}

export function HeaderTemporary(): React.JSX.Element {
    const [scrolled, setScrolled] = useState(false)
    const [isMobile, setIsMobile] = useState(false)

    const isFullSite = useFeatureFlag("fullsite")

    useEffect(() => {
        const handleScroll = (): void => {
            setScrolled(window.scrollY > 0)
        }

        const handleResize = (): void => {
            setIsMobile(window.innerWidth < 1024)
        }

        handleResize()
        window.addEventListener("scroll", handleScroll)
        window.addEventListener("resize", handleResize)

        return () => {
            window.removeEventListener("scroll", handleScroll)
            window.removeEventListener("resize", handleResize)
        }
    }, [])

    const showDarkTheme = scrolled

    return (
        <div>
            <header className={`header ${scrolled ? "header-scrolled" : ""}`}>
                <img
                    src={showDarkTheme ? logo : logoWhite}
                    style={{ position: "absolute", left: isMobile ? "20px" : "48px", height: "32px" }}
                    alt="ecsenz logo"
                />
                <div
                    style={{
                        position: "absolute",
                        right: isMobile ? "20px" : "48px",
                        display: "flex",
                        alignItems: "center",
                        gap: isMobile ? "16px" : "32px",
                    }}
                >
                    <a href="#contact" style={{ display: "flex", alignItems: "center", textDecoration: "none" }}>
                        <img
                            src={contactIcon}
                            alt="Contact"
                            style={{
                                width: "26px",
                                height: "26px",
                                filter: showDarkTheme ? "none" : "brightness(0) invert(1)",
                            }}
                        />
                    </a>
                    {isFullSite && (
                        <a href="https://test.internal.ecsenz.com/ecsenzwebapp/latest/#">
                            <button
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                    background: "none",
                                    border: "none",
                                    cursor: "pointer",
                                    padding: isMobile ? "8px" : "0",
                                }}
                            >
                                <img
                                    src={profileIcon}
                                    alt="Profile"
                                    style={{
                                        width: "24px",
                                        height: "24px",
                                        filter: showDarkTheme ? "none" : "brightness(0) invert(1)",
                                    }}
                                />
                            </button>
                        </a>
                    )}
                </div>
            </header>
        </div>
    )
}